import React from 'react';
import { data } from '../../data';
import CountUp from 'react-countup';
import { motion } from 'framer-motion';

const cardVariants = {
  hidden: { opacity: 0, y: 40, scale: 0.95 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.45, ease: "easeOut" }
  }
};

const WhyChooseUs = () => {
  const { Numbers } = data;

  return (
    <section className="px-4 py-4 lg:pt-8 bg-gray-50 overflow-hidden">
      <div className="max-w-[90vw] mx-auto">

        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className="text-center mb-8 lg:mb-16"
        >
          <h2 className="text-center text-3xl md:text-4xl font-extrabold tracking-tight text-transparent bg-clip-text bg-[var(--bg-primary)] drop-shadow-sm mb-2 lg:mb-2">
            Why Choose Us
          </h2>
          <div className="w-40 h-1 bg-[var(--bg-primary)] mx-auto rounded-full mb-2"></div>
          <p className="text-sm md:text-sm text-gray-500 text-center max-w-md mx-auto">
             Reliable solutions, expert guidance, and service you can trust—every step of the way.
          </p>
        </motion.div>

        {/* Cards Grid */}
        <motion.div
          className="
            grid gap-5
            grid-cols-2        /* Mobile → 2 cards */
            md:grid-cols-3
            lg:grid-cols-4    /* Desktop → 4 cards in one row */
          "
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {Numbers.map((nm, i) => (
            <motion.div
              key={i}
              variants={cardVariants}
              whileHover={{
                y: -10,
                scale: 1.04,
                boxShadow: "0px 20px 40px rgba(59,130,246,0.25)"
              }}
              transition={{ type: "spring", stiffness: 180, damping: 14 }}
              className="
                bg-white rounded-2xl border border-gray-100 shadow-md
                flex flex-col items-center text-center
                px-4 py-6          /* Mobile padding */
                sm:px-6 sm:py-8    /* Desktop padding */
                relative overflow-hidden group
              "
            >
              {/* Hover Glow */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-500/10 to-purple-500/10 opacity-0 group-hover:opacity-100 transition duration-300" />

              {/* Number Circle */}
              <motion.div
                whileHover={{ scale: 1.15, rotate: 10 }}
                transition={{ type: "spring", stiffness: 250 }}
                className="
                  w-12 h-12           /* Mobile size */
                  sm:w-16 sm:h-16
                  rounded-full bg-[var(--bg-primary)]
                  flex items-center justify-center mb-4 shadow-md z-10
                "
              >
                <span className="text-white font-bold text-sm ">
                  <CountUp start={0} end={nm.innumber} duration={1.4} />+
                </span>
              </motion.div>

              {/* Title */}
              <h4 className="z-10 font-bold text-gray-900 text-sm sm:text-lg mb-1">
                {nm.name}
              </h4>

              {/* Description */}
              <p className="z-10 text-gray-500 text-xs sm:text-sm leading-relaxed">
                {nm.description}
              </p>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
};

export default WhyChooseUs;
